import React, { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { Button, Divider, IconButton, Popover, Stack, SxProps } from "@mui/material";
import { AutocompleteMeasures } from "components/reports/Set-table-columns/AutocompleteMeasures";
import { IInvestorViewTable } from "store/types";

interface Props {
  columnsSettings: IInvestorViewTable;
  onSubmit: (queries: IInvestorViewTable) => void;
  sx?: SxProps;
}

export const ColumnsSetMenu: React.FC<Props> = ({ onSubmit, columnsSettings, sx }) => {
  const [localQueriesState, setLocalQueriesState] = useState<IInvestorViewTable>(columnsSettings);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <IconButton
        sx={{
          ...sx,
          bgcolor: "#0A3142",
          ":hover": { bgcolor: "#0A3142" },
          zIndex: 6
        }}
        size="sm"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <AddIcon sx={{ color: "#fff" }} />
      </IconButton>
      {anchorEl && (
        <Popover
          anchorEl={anchorEl}
          open={!!anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          onClose={() => setAnchorEl(null)}
        >
          <Stack direction="column" gap="15px" sx={{ boxShadow: "sm", bgcolor: "white" }}>
            <Stack sx={{ p: "30px" }} gap="15px">
              <Divider sx={{ borderColor: "#dae0e2" }} />
              <AutocompleteMeasures
                sx={{ width: "520px" }}
                label="Parameter"
                queries={localQueriesState}
                setQueryValue={(field, value) => {
                  setLocalQueriesState((prevQueries) => ({
                    ...prevQueries,
                    [field]: value
                  }));
                }}
                onClear={() => {
                  setLocalQueriesState({
                    measures: [],
                    characteristics: [],
                    calculatedFields: []
                  });
                }}
              />
            </Stack>
            <Stack
              flexDirection="row"
              justifyContent="flex-end"
              alignItems="center"
              gap="10px"
              sx={{ borderTop: "1px solid #dae0e2", p: "30px" }}
            >
              <Button
                size="sm"
                variant="outlined"
                sx={{ minWidth: "53px" }}
                onClick={() => {
                  setAnchorEl(null);
                  setLocalQueriesState(
                    columnsSettings || {
                      measures: [],
                      characteristics: [],
                      calculatedFields: []
                    }
                  );
                }}
              >
                Cancel
              </Button>
              <Button
                size="sm"
                variant="contained"
                sx={{ backgroundColor: "#071F35", minWidth: "46px" }}
                onClick={() => {
                  onSubmit(localQueriesState);
                  setAnchorEl(null);
                }}
              >
                Okay
              </Button>
            </Stack>
          </Stack>
        </Popover>
      )}
    </>
  );
};
